'use client';

import React, { useState, useEffect } from 'react';

import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { Heading } from '../../../components/Heading/Heading';
import { FormInput } from '../../../components/Inputs/FormInput/FormInput';
import { getPageUrl } from '../../../helpers/urls';
import { GetAllBrands_entry } from '../../../interfaces/graphql';

export type IAlphabet = Record<string, GetAllBrands_entry[]>;
interface IProps {
  brands?: IAlphabet;
}

export const SearchBrands = ({ brands }: IProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<[string, GetAllBrands_entry[]][]>(
    Object.entries(brands || {}),
  );

  useEffect(() => {
    const list = Object.entries(brands || {});
    const results = list.filter(([_, values]) => {
      return values.find(v => v.displayName.toLowerCase().includes(searchTerm.toLowerCase()));
    });
    setSearchResults(results);
  }, [searchTerm, brands]);

  return (
    <div data-testid="Filtered-Brands">
      <div className="my-6">
        <FormInput
          id="search-brand"
          label="Search brands"
          labelClassName="hidden"
          value={searchTerm}
          onChange={val => setSearchTerm(val)}
        />
      </div>
      {searchResults.map(([alphabet, values], groupIndex) => {
        return (
          <div className="py-2" key={groupIndex}>
            <Heading variant="md">{alphabet}</Heading>
            {values.map((brand, brandIndex) => {
              return (
                <div className="mb-4" key={brandIndex}>
                  {brand.displayName.toLowerCase().includes(searchTerm.toLowerCase()) && (
                    <InternalLink
                      to={getPageUrl(brand.externalId, brand.displayName)}
                      key={brand.externalId}
                      variant="textPrimary"
                    >
                      {brand.displayName}
                    </InternalLink>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
